export const CM_OUTCOMES_EXP_FLAG = 'pen-3644_v3'
